import Dropkick from 'dropkickjs';

const moduleName = 'calculation';

export function calculation() {

    Array.from(document.querySelectorAll('.js-calculation')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const calculation = self;
        const calculationSelect = calculation.querySelector('.js-calculation-select');
        const calculationGroups = calculation.querySelectorAll('.js-calculation-group');

        calculationSelect.addEventListener('change', () => {
            const calculationSelectValue = el.value;

            Array.from(calculationGroups).forEach((calculationGroup) => {
                const calculationGroupInput = calculationGroup.querySelector('input');

                if (calculationSelectValue == calculationGroup.dataset.type) {
                    calculationGroup.classList.remove('_hidden');
                    calculationGroupInput.disabled = false;
                    calculationGroupInput.required = true;
                } else {
                    calculationGroup.classList.add('_hidden');
                    calculationGroupInput.disabled = true;
                    calculationGroupInput.required = false;
                }
            });
        });

        const securitySelect = document.getElementById('security-request-select')
        const addSelect = document.querySelector('.js-add-select')

        if (securitySelect) {
            securitySelect.addEventListener('change', e => {
                console.log(e.target.value)
                if (e.target.value === '1') {
                    addSelect.classList.remove('hidden')
                } else {
                    addSelect.classList.add('hidden')
                }
            })
        }

    });

}